module.exports = __webpack_public_path__ + "static/media/bbs_header_print.6b6f7c5d.gif";